import { OnChanges, SimpleChanges } from '@angular/core';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LoggerService } from '../providers/logger.service';
import { TwfstyleService } from '../providers/twfstyle.service';

@Component({
  selector: 'app-eraser',
  template: `<div #abxElementWrapper><canvas #abxElement id='abx-element'></canvas><div id='eraser-listener' #eraserListener [ngStyle]="listenerStyle"></div></div>`,
  styles: [
  ]
})
export class EraserComponent implements OnInit, AfterViewInit, OnChanges {

  canvas: any // = $element.find("canvas")[0];
  //listener: any //  = $element.find("#eraser-listener")[0];
  @ViewChild('eraserListener') listener: ElementRef<HTMLElement>;
  mouseDown = false;
  ctx = undefined;
  path = undefined;

  touchEvents = 'ontouchstart' in document.documentElement;
  scale = undefined;
  listenerStyle = { position: "absolute", top: "0px", left: "0px", "z-index": 2000 };

  allPaths = [];

  color: any;
  @Input() inkWidth: any;
  @Input() active: any;

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() erasingStarted: EventEmitter<any> = new EventEmitter();

  @ViewChild("abxElement", { static: false }) abxElement: ElementRef;
  @ViewChild("abxElementWrapper", { static: false }) abxElementWrapper: ElementRef;
  isAfterAfterViewInit: boolean = false;

  constructor(private logger: LoggerService, private twfStyle: TwfstyleService, private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (this.isAfterAfterViewInit && 'active' in changes) {
        this.activateEraser(this.active);
      }
    } catch (e) {
      this.logger.logInternalError("EraserComponent: $onChanges", e.message);
    }
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.abxElementWrapper.nativeElement.addEventListener('pointerdown', (e) => {
      if (this.active) this.handleMouseDown(e);
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('touchstart', (e) => {
      if (this.active) this.handleMouseDown(e);
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('pointermove', (e) => {
      if (this.active) this.handleMouseMove(e);
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('touchmove', (e) => {
      if (this.active) this.handleMouseMove(e);
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('pointerup', (e) => {
      if (this.active) this.handleMouseUp(e);
    }, { passive: false });

    this.activateEraser(this.active);
    this.isAfterAfterViewInit = true;
  }

  getScale() {
    if (this.scale !== undefined) return this.scale;

    var scale = 1;
    //var transform = window.getComputedStyle(this.elementRef.nativeElement.parentElement).transform;
    var transform = document.getElementById("page").style.transform;
    if (transform !== undefined) {
      if (transform.startsWith("scale(")) {
        var ttransform = transform.substring(7).split(",");
        scale = parseFloat(ttransform[0]);
      }
    }
    this.scale = scale;
    return scale;
  }

  getOffsetX(ev) {
    var scale = this.getScale();
    var rect = this.canvas.getBoundingClientRect();
    return (ev.touches[0].clientX - rect.left) / scale;
  }

  getOffsetY(ev) {
    var scale = this.getScale();
    var rect = this.canvas.getBoundingClientRect();
    return (ev.touches[0].clientY - rect.top) / scale;
  }

  activateEraser(active) {

    try {
      if (active) {

        // Copy the background to a canvas
        var img = document.getElementById('background') as HTMLImageElement;
        const canvasEl: HTMLCanvasElement = this.abxElement.nativeElement;

        canvasEl.width = img.offsetWidth;
        canvasEl.height = img.offsetHeight;
        canvasEl.getContext('2d').drawImage(img, 0, 0, img.width, img.height);

        this.canvas = canvasEl;

        this.listener.nativeElement.style.width = img.width + "px";
        this.listener.nativeElement.style.height = img.height + "px";

        this.color = undefined;
        this.scale = undefined;

        this.allPaths = [];

      } else {
        if (this.canvas !== undefined) this.save.emit({ image: this.canvas.toDataURL("image/jpeg") });
      }
    } catch (e) {
      this.logger.logInternalError("ERASER: activate", e.message);
    }

  }

  //initMouseListeners(active) {

  //  try {
  //    var listener = undefined//$(this.listener);
  //    if (this.touchEvents) {
  //      if (active) {
  //        listener.on("touchstart", this.handleMouseDown);
  //        listener.on("touchend", this.handleMouseUp);
  //        listener.on("touchcancel", this.handleMouseUp);
  //        listener.on("touchmove", this.handleMouseMove);
  //      } else {
  //        this.mouseDown = false;
  //        listener.off("touchstart");
  //        listener.off("touchend");
  //        listener.off("touchcancel");
  //        listener.off("touchmove");
  //      }
  //    }
  //    else {
  //      // Desktop - mouse events
  //      if (active) {
  //        listener.on("mousedown", this.handleMouseDown);
  //        listener.on("mouseup", this.handleMouseUp);
  //        listener.on("mouseleave", this.handleMouseUp);
  //        listener.on("mousemove", this.handleMouseMove);
  //      } else {
  //        this.mouseDown = false;
  //        listener.off("mousedown");
  //        listener.off("mouseup");
  //        listener.off("mouseleave");
  //        listener.off("mousemove");
  //      }
  //    }

  //  } catch (e) {
  //    this.logger.logInternalError("ERASER: listeners", e.message);
  //  }
  //}

  handleMouseUp(ev) {

    this.mouseDown = false;

    this.allPaths.push(this.path);
    this.color = undefined;

    ev.preventDefault();
    ev.stopPropagation();
  }

  handleMouseDown(ev) {

    try {

      var x = this.touchEvents ? this.getOffsetX(ev) : ev.offsetX;
      var y = this.touchEvents ? this.getOffsetY(ev) : ev.offsetY;

      // Get the eraser color
      if (this.color === undefined) {

        var ctx = this.canvas.getContext('2d');

        // Get four points
        var color1 = ctx.getImageData(x, y, 1, 1).data;
        var color2 = ctx.getImageData(x + 10, y + 10, 1, 1).data;
        var color3 = ctx.getImageData(x - 10, y - 10, 1, 1).data;
        var color4 = ctx.getImageData(x + 10, y - 10, 1, 1).data;

        var colors = [color1, color2, color3, color4];

        // Select the brightest color
        this.color = colors[0];
        var brightnes = 0;
        var l;

        for (var i = 0; i < 3; i++) {
          l = this.rgb2hsl(colors[i])[2];
          if (l > brightnes && colors[i][3] === 255) {
            brightnes = l;
            this.color = colors[i];
          }
        }

      }

      this.mouseDown = true;

      this.ctx = this.canvas.getContext('2d');
      this.ctx.lineWidth = this.inkWidth;
      this.ctx.strokeStyle = "rgba(" + this.color[0] + "," + this.color[1] + "," + this.color[2] + "," + this.color[3] + ")";
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";

      this.path = { data: new Path2D(), width: this.inkWidth }
      this.path.data.moveTo(x, y);

      ev.preventDefault();
      ev.stopPropagation();

    } catch (e) {
      this.logger.logInternalError("ERASER: mouseDown", e.message);
    }
  }

  handleMouseMove(ev) {

    try {
      if (this.mouseDown) {

        if (!this.touchEvents) ev.preventDefault();

        var x = this.touchEvents ? this.getOffsetX(ev) : ev.offsetX;
        var y = this.touchEvents ? this.getOffsetY(ev) : ev.offsetY;

        this.path.data.lineTo(x, y);
        this.ctx.stroke(this.path.data);

        this.erasingStarted.emit();
        ev.preventDefault();
        ev.stopPropagation();
      }
    } catch (e) {
      this.logger.logInternalError("ERASER: mouseMove", e.message);
    }
  }

  rgb2hsl(color) {

    var r = color[0] / 255.0;
    var g = color[1] / 255.0;
    var b = color[2] / 255.0;

    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);

    var h, s;
    var l = (max + min) / 2;

    if (max === min) {
      s = 0;
      s = 0;
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) {
        h = (g - b) / d + (g < b ? 6 : 0);
      } else if (max === g) {
        h = (b - r) / d + 2;
      } else {
        h = (r - g) / d + 4;
      }
      h /= 6;
    }

    return [h, s, l];
  }

  /**
   * HostListeners 
   */

  //@HostListener('document:mousedown', ['$event'])
  //pressMouseEventHandler(event: MouseEvent) {
  //  if (this.active) this.handleMouseDown(event);
  //}

  //@HostListener('document:touchstart', ['$event'])
  //pressTouchEventHandler(event: TouchEvent) {
  //  if (this.active) this.handleMouseDown(event);
  //}

  //@HostListener('document:mousemove', ['$event'])
  //mouseDragEventHandler(event: MouseEvent) {
  //  if (this.active) this.handleMouseMove(event);
  //}

  //@HostListener('document:touchmove', ['$event'])
  //touchDragEventHandler(event: TouchEvent) {
  //  if (this.active) this.handleMouseMove(event);
  //}

  //@HostListener('document:mouseup', ['$event'])
  //mouseReleaseEventHandler(event: MouseEvent) {
  //  if (this.active) this.handleMouseUp(event);
  //}

  //@HostListener('document:touchend', ['$event'])
  //touchReleaseEventHandler(event: TouchEvent) {
  //  if (this.active) this.handleMouseUp(event);
  //}
}
